<template>
  <div id="app-details-layout">
    <app-details-header/>
    <app-details-drawer/>
    <app-details-view/>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AppDetailsLayout",
  components: {
    AppDetailsView:() => import(
        './View'
        ),
    AppDetailsHeader: () => import(
        './Header'
        ),
    AppDetailsDrawer: () => import(
        './Drawer'
        )
  },
  mounted() {
    this.findOne()
  },
  methods: {
    ...mapActions('application', ['findOne'])
  }
}
</script>

<style scoped lang="scss">
#app-details-layout {
  min-height: 100%;
  header {
    z-index: 100;
  }
  #app-details-view {
    min-height: 100%;
    width: 100%;
  }
}
</style>
